import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { projectPathParams } from 'Router';
import { fetchProject } from 'clients/projects/client';
import { reactQueryKeys } from 'clients/reactQueryConfig';

import ProjectVersionPage from './components/ProjectVersionPage';

const PrintableView: React.FC = () => {
  const { id } = useParams() as projectPathParams;

  const projectQuery = useQuery({
    queryKey: reactQueryKeys.project(id),
    queryFn: () => fetchProject(id),
  });

  if (!projectQuery.isSuccess) {
    return <></>;
  }

  const project = projectQuery.data;

  return (
    <ProjectVersionPage
      projectVersionMetadata={project.projectVersionMetadatas[0]}
      project={project}
    />
  );
};

export default PrintableView;
